export default "__VITE_ASSET__BKViH4Lm__"